/**
 * Created by dss on 8/9/17.
 */

import {IGeoPoint} from "./igeopoint";

export class MapMath {

    static angleBetweenLocations(sourcePt: IGeoPoint, targetPt: IGeoPoint): number {

        var PI = Math.PI;
        var lat1 = sourcePt.lat * PI / 180;
        var long1 = sourcePt.lng * PI / 180;
        var lat2 = targetPt.lat * PI / 180;
        var long2 = targetPt.lng * PI / 180;

        var dLon = (long2 - long1);

        var y = Math.sin(dLon) * Math.cos(lat2);
        var x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);

        var brng = Math.atan2(y, x);

        brng = MapMath.toDegrees(brng);
        brng = (brng + 360) % 360;

        return brng;
    }

    static toDegrees(rad: number) {
        return rad * 180 / Math.PI;
    }

    static toRadians(deg: number): number {
        return deg * Math.PI / 180;
    }
}


// WEBPACK FOOTER //
// ./src/math.ts